export default __webpack_public_path__ + "static/media/apple-pay.79c23ff0.79c23ff0.png";